// Fonctions support — SCD « Dynamique groupe » (30/06).
// Refonte retail : les 21 personnages historiques (noms conservés) pivotent
// vers des rôles de siège social d'un groupe de commerce de détail.
// Recrutement possible uniquement si : 3+ magasins en propre (dynamique
// groupe enclenchée) ET investissement « Siège social » réalisé.
/* i18n-keep-file */
//
// Bonus types (consommés par retailSlice / taxSlice / bankSlice / events) :
/* i18n-keep */
//   { type: 'revenue', value: 0.10 }                  → +10 % CA réseau magasins
//   { type: 'achat_discount', value: 0.03 }           → -3 % prix d'achat fournisseurs
//   { type: 'masse_salariale_discount', value: 0.05 } → -5 % masse salariale magasins
//   { type: 'maintenance_discount', value: 0.20 }     → -20 % entretien des magasins
//   { type: 'fiabilite_fournisseur', value: 0.25 }    → -25 % risque de retard fournisseur
//   { type: 'tax_reduction', value: 0.03 }            → -3 % IS
//   { type: 'agios_reduction', value: 0.10 }          → -10 % agios quotidiens
//   { type: 'reputation_passive', value: 1 }          → +N réputation / 30 j
//   { type: 'notoriety_passive', value: 1 }           → +N notoriété / 30 j
//   { type: 'satisfaction_passive', value: 2 }        → +N satisfaction clients / 30 j
//   { type: 'event_rep_mitigation', value: 0.50 }     → impacts réputation des aléas ÷ 2
//   { type: 'legal_*' / 'tax_auto_provisioning' / 'rse_*' } → mécaniques dédiées

export const SUPPORT_FAMILIES = [
  { id: 'admin', name: 'Administration / Direction', icon: 'ClipboardList' },
  { id: 'commerce', name: 'Commerce & Développement', icon: 'Briefcase' },
  { id: 'marketing', name: 'Marketing', icon: 'BarChart3' },
  { id: 'communication', name: 'Communication', icon: 'Megaphone' },
  { id: 'achats', name: 'Achats / Centrale', icon: 'ShoppingCart' },
  { id: 'finance', name: 'Comptabilité / Finance', icon: 'Calculator' },
  { id: 'rh', name: 'Ressources Humaines', icon: 'Users' },
  { id: 'sav', name: 'Relation client', icon: 'Headphones' },
  // 30/06 — ex-famille « Garage » (monde transport) reconvertie Supply chain.
  { id: 'logistique', name: 'Supply chain / Logistique', icon: 'Truck' },
  { id: 'qhse', name: 'QHSE / RSE', icon: 'ShieldCheck' },
  { id: 'juridique', name: 'Juridique / Conseil', icon: 'Scale' },
];

export const SUPPORT_ROLES = [
  // ===== ADMINISTRATION / DIRECTION =====
  {
    id: 'role-nathalie-robert',
    familyId: 'admin',
    role: 'Assistante de direction',
    name: 'Nathalie Robert', age: 38,
    portrait: '/support-portraits/role-nathalie-robert.webp',
    level: 'Junior',
    background: 'Formation Gestion, méthodique et rigoureuse, soulage la direction du groupe sur tout le suivi administratif des magasins.',
    monthlyCost: 2414,
    prerequisite: { type: 'monthlyRevenue', value: 10000, label: 'CA > 10 000 €/mois' },
    bonuses: [
      { type: 'revenue', value: 0.04, label: '+4 % CA réseau (administratif fluidifié)' },
    ],
    unlocks: [],
  },
  {
    id: 'role-christophe-faure',
    familyId: 'admin',
    role: 'Directeur de réseau',
    name: 'Rémi Forni', age: 45,
    portrait: '/support-portraits/role-christophe-faure.webp',
    level: 'Senior',
    background: 'Cadre retail pendant 15 ans, anime les directeurs de magasin et harmonise les méthodes de vente du réseau.',
    monthlyCost: 4260,
    prerequisite: { type: 'monthlyRevenue', value: 25000, label: 'CA > 25 000 €/mois' },
    bonuses: [
      { type: 'revenue', value: 0.10, label: '+10 % CA réseau (pilotage des magasins)' },
      { type: 'reputation_passive', value: 1, label: '+1 réputation / mois (enseigne fiable)' },
    ],
    unlocks: [],
  },

  // ===== COMMERCE & DÉVELOPPEMENT =====
  {
    id: 'role-lea-bertrand',
    familyId: 'commerce',
    role: 'Chargée de développement',
    name: 'Léa Bertrand', age: 26,
    portrait: '/support-portraits/role-lea-bertrand.webp',
    level: 'Junior',
    background: 'Ex-grande distribution sportive, énergique, déniche les emplacements et anime les ventes B2B locales.',
    monthlyCost: 2200,
    prerequisite: { type: 'monthlyRevenue', value: 5000, label: 'CA > 5 000 €/mois' },
    bonuses: [
      { type: 'revenue', value: 0.03, label: '+3 % CA réseau (ventes B2B locales)' },
    ],
    unlocks: [],
  },
  {
    id: 'role-marc-dupuis',
    familyId: 'commerce',
    role: 'Responsable grands comptes',
    name: 'Marc Dupuis', age: 42,
    portrait: '/support-portraits/role-marc-dupuis.webp',
    level: 'Senior',
    background: '15 ans dans le commerce B2B, signe des comptes professionnels (CE, collectivités, hôtellerie) pour tout le réseau.',
    monthlyCost: 3550,
    prerequisite: { type: 'monthlyRevenue', value: 20000, label: 'CA > 20 000 €/mois' },
    bonuses: [
      { type: 'revenue', value: 0.08, label: '+8 % CA réseau (comptes professionnels)' },
    ],
    unlocks: [],
  },
  {
    id: 'role-sylvie-marchand',
    familyId: 'commerce',
    role: 'Directrice commerciale groupe',
    name: 'Sylvie Marchand', age: 51,
    portrait: '/support-portraits/role-sylvie-marchand.webp',
    level: 'Expert',
    background: 'Ancienne cadre retail grands comptes, structure la stratégie commerciale multi-enseignes du groupe.',
    monthlyCost: 5800,
    prerequisite: { type: 'roleHired', value: 'role-marc-dupuis', label: 'Marc Dupuis recruté + CA > 50 000 €/mois' },
    extraPrerequisite: { type: 'monthlyRevenue', value: 50000 },
    bonuses: [
      { type: 'revenue', value: 0.12, label: '+12 % CA réseau (stratégie commerciale)' },
    ],
    unlocks: [],
  },

  // ===== MARKETING =====
  {
    id: 'role-yanis-elkaroui',
    familyId: 'marketing',
    role: 'Chargé de marketing digital',
    name: 'Yanis El Karoui', age: 24,
    portrait: '/support-portraits/role-yanis-elkaroui.webp',
    level: 'Junior',
    background: 'École de communication, créatif, fait rayonner l\'enseigne sur les canaux digitaux.',
    monthlyCost: 2400,
    prerequisite: { type: 'monthlyRevenue', value: 8000, label: 'CA > 8 000 €/mois' },
    bonuses: [
      { type: 'notoriety_passive', value: 1, label: '+1 notoriété / mois (présence digitale)' },
      { type: 'revenue', value: 0.02, label: '+2 % CA réseau (effet vitrine)' },
    ],
    unlocks: [],
  },
  {
    id: 'role-sherazade-fetitou',
    familyId: 'marketing',
    role: 'Responsable marketing enseigne',
    name: 'Sherazade Fetitou', age: 40,
    portrait: '/support-portraits/role-sherazade-fetitou.webp',
    level: 'Senior',
    background: 'Ex-terrain reconvertie agence, structure une vraie stratégie de marque pour tous les magasins du groupe.',
    monthlyCost: 4100,
    prerequisite: { type: 'roleHired', value: 'role-yanis-elkaroui', label: 'Yanis El Karoui recruté' },
    bonuses: [
      { type: 'notoriety_passive', value: 2, label: '+2 notoriété / mois' },
      { type: 'satisfaction_passive', value: 2, label: '+2 satisfaction clients / mois (image de marque)' },
    ],
    unlocks: [],
  },

  // ===== COMMUNICATION =====
  {
    id: 'role-thomas-vidal',
    familyId: 'communication',
    role: 'Community Manager',
    name: 'Thomas Vidal', age: 28,
    portrait: '/support-portraits/role-thomas-vidal.webp',
    level: 'Junior',
    background: 'Freelance, gère les réseaux sociaux des magasins et désamorce les premiers bad buzz.',
    monthlyCost: 2100,
    prerequisite: { type: 'monthlyRevenue', value: 6000, label: 'CA > 6 000 €/mois' },
    bonuses: [
      { type: 'revenue', value: 0.02, label: '+2 % CA réseau (animation des communautés)' },
      { type: 'event_rep_mitigation', value: 0.50, label: '-50 % impact aléas réputation' },
    ],
    unlocks: [],
  },
  {
    id: 'role-aicha-diallo',
    familyId: 'communication',
    role: 'Attachée de presse',
    name: 'Aïcha Diallo', age: 38,
    portrait: '/support-portraits/role-aicha-diallo.webp',
    level: 'Senior',
    background: 'Ex-attachée de presse retail, transforme chaque crise en opportunité narrative pour l\'enseigne.',
    monthlyCost: 3700,
    prerequisite: { type: 'roleHired', value: 'role-yanis-elkaroui', label: 'Yanis El Karoui recruté' },
    bonuses: [
      { type: 'notoriety_passive', value: 1.5, label: '+1,5 notoriété / mois' },
      { type: 'reputation_passive', value: 0.5, label: '+0,5 réputation / mois (gestion de crise)' },
    ],
    unlocks: ['crisis_comm'],
  },

  // ===== ACHATS / CENTRALE =====
  {
    id: 'role-karim-benali',
    familyId: 'achats',
    role: 'Acheteur réseau',
    name: 'Karim Benali', age: 30,
    portrait: '/support-portraits/role-karim-benali.webp',
    level: 'Junior',
    background: 'Ex-acheteur en centrale de distribution, ferme et analytique, massifie les commandes du réseau.',
    monthlyCost: 2600,
    prerequisite: { type: 'magasinCount', value: 3, label: '3+ magasins en propre' },
    bonuses: [
      { type: 'achat_discount', value: 0.02, label: '-2 % sur les prix d\'achat fournisseurs' },
    ],
    unlocks: [],
  },
  {
    id: 'role-helene-pichon',
    familyId: 'achats',
    role: 'Responsable achats groupe',
    name: 'Hélène Pichon', age: 45,
    portrait: '/support-portraits/role-helene-pichon.webp',
    level: 'Senior',
    background: 'Category manager aguerrie, négocie des conditions cadres très favorables avec tous les fournisseurs.',
    monthlyCost: 4200,
    prerequisite: { type: 'roleHired', value: 'role-karim-benali', label: 'Karim Benali recruté + 4+ magasins' },
    extraPrerequisite: { type: 'magasinCount', value: 4 },
    bonuses: [
      { type: 'achat_discount', value: 0.03, label: '-3 % supplémentaires sur les prix d\'achat' },
    ],
    unlocks: ['contrats_cadres'],
  },

  // ===== COMPTABILITÉ / FINANCE =====
  {
    id: 'role-sophie-lambert',
    familyId: 'finance',
    role: 'Comptable',
    name: 'Sophie Lambert', age: 32,
    portrait: '/support-portraits/role-sophie-lambert.webp',
    level: 'Junior',
    background: 'DCG en poche, méticuleuse, sait optimiser les déductions fiscales du groupe.',
    monthlyCost: 2800,
    prerequisite: { type: 'monthlyRevenue', value: 15000, label: 'CA > 15 000 €/mois' },
    bonuses: [
      { type: 'tax_reduction', value: 0.03, label: '-3 % IS (optimisation fiscale)' },
    ],
    unlocks: ['audit_fiscal'],
  },
  {
    id: 'role-pierre-marchetti',
    familyId: 'finance',
    role: 'Directeur administratif et financier',
    name: 'Tristan Midal', age: 48,
    portrait: '/support-portraits/role-pierre-marchetti.webp',
    level: 'Senior',
    background: "Ex-DAF d'un groupe de distribution, sait négocier avec les banques et anticiper l'IS.",
    monthlyCost: 5200,
    prerequisite: { type: 'roleHired', value: 'role-sophie-lambert', label: 'Sophie Lambert recrutée' },
    bonuses: [
      { type: 'tax_auto_provisioning', value: 1, label: 'Débloque le provisionnement auto TVA + IS (zéro mauvaise surprise au bilan)' },
      { type: 'agios_reduction', value: 0.10, label: '-10 % agios' },
    ],
    unlocks: ['negociation_taux', 'fiscal_simulator', 'tax_auto_provisioning'],
  },

  // ===== RH =====
  {
    id: 'role-nadia-cheikh',
    familyId: 'rh',
    role: 'Directrice des ressources humaines',
    name: 'Nadia Cheikh', age: 36,
    portrait: '/support-portraits/role-nadia-cheikh.webp',
    level: 'Senior',
    background: 'Ex-cabinet de recrutement, professionnalise les contrats des équipes magasin et optimise la masse salariale.',
    monthlyCost: 3300,
    bonuses: [
      { type: 'masse_salariale_discount', value: 0.05, label: '-5 % masse salariale des magasins' },
      { type: 'satisfaction_passive', value: 2, label: '+2 satisfaction clients / mois (équipes mieux formées)' },
    ],
    unlocks: ['hr_dashboard'],
  },
  {
    id: 'role-karim-sefrioui',
    familyId: 'rh',
    role: 'Chasseur de têtes retail',
    name: 'Karim Sefrioui', age: 42,
    portrait: '/support-portraits/role-karim-sefrioui.webp',
    level: 'Senior',
    background: 'Tête chercheuse du retail — place les bons profils au bon poste et réduit les coûts de recrutement.',
    monthlyCost: 4200,
    prerequisite: { type: 'roleHired', value: 'role-nadia-cheikh', label: 'Nadia Cheikh recrutée' },
    bonuses: [
      { type: 'masse_salariale_discount', value: 0.03, label: '-3 % supplémentaires (recrutements ciblés)' },
    ],
    unlocks: [],
  },

  // ===== RELATION CLIENT =====
  {
    id: 'role-lucas-mercier',
    familyId: 'sav',
    role: 'Chargé de relation client',
    name: 'Lucas Mercier', age: 22,
    portrait: '/support-portraits/role-lucas-mercier.webp',
    level: 'Junior',
    background: 'Patient et clair, gère les réclamations clients de tous les magasins du réseau.',
    monthlyCost: 2000,
    prerequisite: { type: 'monthlyRevenue', value: 10000, label: 'CA > 10 000 €/mois' },
    bonuses: [
      { type: 'reputation_passive', value: 0.5, label: '+0,5 réputation / mois' },
      { type: 'satisfaction_passive', value: 1, label: '+1 satisfaction clients / mois' },
    ],
    unlocks: [],
  },
  {
    id: 'role-ines-bouchard',
    familyId: 'sav',
    role: 'Responsable expérience client',
    name: 'Inès Bouchard', age: 29,
    portrait: '/support-portraits/role-ines-bouchard.webp',
    level: 'Senior',
    background: 'Structure un vrai service client omnicanal, méthodique et empathique.',
    monthlyCost: 3200,
    prerequisite: { type: 'roleHired', value: 'role-lucas-mercier', label: 'Lucas Mercier recruté' },
    bonuses: [
      { type: 'satisfaction_passive', value: 3, label: '+3 satisfaction clients / mois' },
      { type: 'event_rep_mitigation', value: 0.50, label: '-50 % impact aléas réputation' },
    ],
    unlocks: [],
  },

  // ===== SUPPLY CHAIN / LOGISTIQUE =====
  {
    id: 'role-mehdi-ferhat',
    familyId: 'logistique',
    role: 'Coordinateur supply chain',
    name: 'Mehdi Ferhat', age: 27,
    portrait: '/support-portraits/role-mehdi-ferhat.webp',
    level: 'Junior',
    background: 'Débrouillard et efficace, suit chaque commande fournisseur et relance avant que ça dérape.',
    monthlyCost: 2700,
    prerequisite: { type: 'magasinCount', value: 3, label: '3+ magasins en propre' },
    bonuses: [
      { type: 'fiabilite_fournisseur', value: 0.25, label: '-25 % de risque de retard fournisseur' },
    ],
    unlocks: [],
  },
  {
    id: 'role-bruno-lavergne',
    familyId: 'logistique',
    role: 'Responsable logistique groupe',
    name: 'Bruno Lavergne', age: 50,
    portrait: '/support-portraits/role-bruno-lavergne.webp',
    level: 'Senior',
    background: 'Vétéran des flux retail, anticipe les ruptures de la chaîne d\'approvisionnement avant qu\'elles ne surviennent.',
    monthlyCost: 4500,
    prerequisite: { type: 'roleHired', value: 'role-mehdi-ferhat', label: 'Mehdi Ferhat recruté + 4+ magasins' },
    extraPrerequisite: { type: 'magasinCount', value: 4 },
    bonuses: [
      { type: 'fiabilite_fournisseur', value: 0.25, label: '-25 % de risque de retard supplémentaires' },
      { type: 'maintenance_discount', value: 0.20, label: '-20 % entretien des magasins' },
    ],
    unlocks: [],
  },

  // ===== QHSE / RSE =====
  {
    id: 'role-claire-marechal',
    familyId: 'qhse',
    role: 'Responsable QHSE / RSE',
    name: 'Claire Maréchal', age: 36,
    portrait: '/support-portraits/role-claire-marechal.webp',
    level: 'Senior',
    background:
      "Ingénieure HSE certifiée ISO 14001 et 45001. Pilote la sécurité des magasins (ERP), la responsabilité " +
      "sociétale (CO2, parité, salaires) et anticipe les contrôles. Calme, méthodique, refuse les compromis sur la sécurité.",
    monthlyCost: 4100,
    prerequisite: { type: 'monthlyRevenue', value: 35000, label: 'CA > 35 000 €/mois + 3+ magasins' },
    extraPrerequisite: { type: 'magasinCount', value: 3 },
    bonuses: [
      { type: 'reputation_passive', value: 1, label: '+1 réputation / mois (gestion HSE)' },
      { type: 'rse_dashboard', value: 1, label: 'Débloque le tableau de bord RSE (score consolidé)' },
    ],
    unlocks: ['rse_dashboard', 'hse_training_compliance'],
  },

  // ===== JURIDIQUE / CONSEIL =====
  {
    id: 'role-juliette-charron-berthet',
    familyId: 'juridique',
    role: 'Avocate-conseil interne',
    name: 'Maître Juliette Charron-Berthet', age: 42,
    portrait: '/support-portraits/role-juliette-charron-berthet.webp',
    level: 'Senior',
    background:
      "Avocate au Barreau de Paris, 15 ans d'expérience en droit des sociétés et droit social. Couvre tout le " +
      "périmètre du commerce : baux commerciaux, droit de la consommation, contentieux fournisseurs, franchise. " +
      "Pragmatique, négocie plutôt qu'elle ne plaide quand c'est possible.",
    monthlyCost: 8200,
    prerequisite: { type: 'monthlyRevenue', value: 60000, label: 'CA > 60 000 €/mois + 4+ magasins' },
    extraPrerequisite: { type: 'magasinCount', value: 4 },
    bonuses: [
      { type: 'legal_amende_discount', value: 0.30, label: '-30 % sur les amendes et pénalités' },
      { type: 'legal_procedure_speed', value: 0.50, label: '-50 % temps de traitement des procédures' },
      { type: 'reputation_passive', value: 1, label: '+1 réputation / mois (image juridique solide)' },
    ],
    unlocks: ['juridique_defense', 'legal_dashboard', 'cabinet_avocat'],
  },
];

export const getSupportRolesByFamily = (familyId) =>
  SUPPORT_ROLES.filter(r => r.familyId === familyId);

export const getSupportRole = (id) =>
  SUPPORT_ROLES.find(r => r.id === id);

/** Nombre de magasins en propre (principal + réseau) — dynamique groupe à 3. */
export const nbMagasinsEnPropre = (state) =>
  state?.retail ? 1 + (state.retail.magasins || []).length : 0;

export const GROUPE_MAGASINS_MIN = 3;

export const groupeDebloque = (state) => nbMagasinsEnPropre(state) >= GROUPE_MAGASINS_MIN;

const checkSingle = (type, value, state) => {
  switch (type) {
    case 'monthlyRevenue':
      // Critère CA basé sur max(M, M-1) pour ne pas bloquer sur un mois faible.
      {
        const current = state.monthlyRevenues || 0;
        const history = Array.isArray(state.monthlyHistory) ? state.monthlyHistory : [];
        const prev = history.length > 0 ? (history[history.length - 1]?.revenues || 0) : 0;
        return Math.max(current, prev) >= value;
      }
    case 'magasinCount':   return nbMagasinsEnPropre(state) >= value;
    case 'driverCount':    return (state.drivers || []).length >= value;
    case 'vehicleCount':   return (state.vehicles || []).length >= value;
    case 'totalDays':      return (state.totalDays || 0) >= value;
    case 'treasury':       return (state.treasury || 0) >= value;
    case 'roleHired':      return !!(state.hiredSupport || {})[value];
    default: return true;
  }
};

/**
 * Evaluate whether the player meets a role's prerequisite (handles the
 * optional extraPrerequisite combined via AND).
 */
export const evaluatePrerequisite = (role, state) => {
  if (!role) return { ok: true, label: '' };
  const p = role.prerequisite;
  if (!p) return { ok: true, label: '' };
  const main = checkSingle(p.type, p.value, state);
  if (!role.extraPrerequisite) {
    return { ok: main, label: p.label };
  }
  const e = role.extraPrerequisite;
  const extra = checkSingle(e.type, e.value, state);
  return { ok: main && extra, label: p.label };
};
